import Repository from '../axios'

const resource = '/admin/system_setting/customer-sources'

export default {
  getListOfCustomerSource(filterQuery){
    return Repository.get(`/admin/system_setting/customer-source?${filterQuery}`)
  },
  createCustomerSource(payload){
    return Repository.post(`${resource}`,payload)
  },
  deleteCustomerSource(id){
    return Repository.delete(`${resource}/${id}`)
  },
  getCustomerSource(id){
    return Repository.get(`${resource}/${id}`)
  },
  updateCustomerSource(id, payload){
    return Repository.put(`${resource}/${id}`, payload)
  },
  getCustomerSubSources(payload) {
    return Repository.post(`/admin/system_setting/customer-sub-source`, payload)
  }

}
